<template>

<section class="container my-2">
<div class="board shadow">
  <h3>Videos</h3>
  <p class="display-8">Embed videos (privately-hosted MP4s or publicly available content from YouTube or Vimeo) in your pages--statically via plain markup or dynamically with video URLs bound to Symphony components.</p>
  <p>Videos bound to Symphony custom components are responsive while maintaining the video's original aspect ratio, requiring you to specify only the width (percentage) relative to the parent element and a few media queries.</p>

  <br><hr>

  <p class='bold'>● Private video - static binding </p>

  <div class="board charcoal">
    <sym-video
      class="justify-center"
      width="50%"
      videoUrl="http://video:6800/Bruno Mars - 24K Magic (Official Video).mp4"
      posterUrl="http://video:6800/Bruno Mars - 24K Magic (Official Video).jpg"
      subtitleUrl="http://video:6800/Bruno Mars - 24K Magic (Official Video).vtt"
      :autoPlay="false"
      :loop="true"
      overlayColor="pink"
    >
    </sym-video>
  </div>

  <br><hr>

  <p class='bold'>● YouTube video - static binding </p>

  <div class="board charcoal">
    <sym-youtube
      class="justify-center"
      width="50%"
      videoId="UqyT8IEBkvY"
      videoWidth="640"
      videoHeight="360"
      :autoPlay="false"
      :loop="true"
    >
    </sym-youtube>
  </div>

  <br><hr>

  <p class='bold'>● Vimeo video - static binding </p>

  <div class="board charcoal">
    <sym-vimeo
      class="justify-center"
      width="60%"
      videoId="258498657"
      videoWidth="640"
      videoHeight="360"
      :autoPlay="false"
      :loop="false"
    >
    </sym-vimeo>
  </div>

  <br><hr>

  <p class='bold'>● DailyMotion video - static binding </p>

  <div class="board charcoal">
    <sym-dailymotion
      class="justify-center"
      width="80%"
      videoId="x7tefn5"
      videoWidth="640"
      videoHeight="360"
      :autoPlay="false"
      :loop="false"
    >
    </sym-dailymotion>
  </div>

</div>
</section>

</template>

<script>

const videoUrl = 'http://video:6800/';

import PageBase from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'samples-video',

  computed: {
    videoPath () {
      return videoUrl + 'Bruno Mars - 24K Magic (Official Video).mp4';
    },

    subTitlePath () {
      return videoUrl + 'Bruno Mars - 24K Magic (Official Video).vtt';
    },

    posterPath () {
      return videoUrl + 'Bruno Mars - 24K Magic (Official Video).jpg';
    }
  },

}

</script>

<style scoped>

@media (max-width: 1100px) {
  .board{
    padding: 1rem;
  }

  figure >>> .video-wrapper {
    width: 100% !important;
  }

  figure >>> .youtube-wrapper,
  figure >>> .vimeo-wrapper,
  figure >>> .dailymotion-wrapper {
    width: 100% !important;
    padding-bottom: 56.25% !important;
  }

}

@media (max-width: 400px) {
  .board {
    padding: 0;
  }
}

</style>
